<template>
    <div id="errorReports">
        <AppBreadCrumb :paths="[{ title: $t('message.feedback') }]" :select="true"> </AppBreadCrumb>
        <b-container fluid>
            <b-row>
                <b-col>
                    <a-table :columns="cols" :dataSource="errorReports" class="custom-table2">
                        <div slot="messageSlot" slot-scope="report" :key="report.message">
                            <div>
                                {{
                                    report.message.length > 150
                                        ? report.message.substring(0, 50) + "..."
                                        : report.message
                                }}
                            </div>
                            <div v-if="report.message.length > 150"></div>
                        </div>
                        <div slot="dateSlot" slot-scope="report" :key="report.date">
                            <div>
                                {{ report.date | date }}
                            </div>
                        </div>
                        <div slot="imageUrlSlot" slot-scope="report">
                            <div class="d-flex justify-content-center align-items-center">
                                <viewer
                                    :id="report.imageUrl"
                                    :images="[report.imageUrl]"
                                    @inited="(viewer) => inited(viewer, report)"
                                >
                                    <img
                                        v-show="false"
                                        :id="report.imageUrl"
                                        :src="report.imageUrl"
                                        class="img-thumbnail ant-upload-list-picture-card-container"
                                        style="object-fit: cover"
                                    />
                                </viewer>
                                <a-button class="actionButton d-flex align-items-center" @click="show(report._id)">
                                    <md-icon style="color: #c9f7f5">image</md-icon>
                                </a-button>
                            </div>
                        </div>
                    </a-table>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import AppBreadCrumb from "../../components/common/AppBreadCrumb";

import { getErrorReports } from "../../api/errorReport";
import ActionEdit from "../../components/svg/ActionEdit";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";

Vue.use(Viewer);

export default {
    name: "errorReports",
    components: {
        AppBreadCrumb,
        ActionEdit,
    },
    data() {
        return {
            errorReports: [],
            cols: [
                {
                    dataIndex: "siteAlias",
                    key: Math.floor(100000 + Math.random() * 900000),
                    title: this.$t("message.siteAlias"),
                },
                {
                    dataIndex: "reporterType",
                    key: Math.floor(100000 + Math.random() * 900000),
                    title: this.$t("message.type"),
                },
                {
                    scopedSlots: { customRender: "messageSlot" },
                    title: this.$t("message.message"),
                    width: "50%",
                },
                {
                    scopedSlots: { customRender: "dateSlot" },
                    title: this.$t("message.date"),
                },
                {
                    scopedSlots: { customRender: "imageUrlSlot" },
                    title: this.$t("message.imageUrl"),
                },
            ],
            visible: false,
            viewers: {},
        };
    },
    computed: {},
    methods: {
        async getErrorReports() {
            getErrorReports()
                .then((response) => {
                    this.errorReports = response.data.errors;
                })
                .catch((x) => {
                    console.log("get error failed", { x });
                });
        },
        inited(viewer, report) {
            this.viewers[report._id] = viewer;
        },
        show(id) {
            console.log("wiever optins", { viewers: this.viewers });
            if (this.viewers[id]) this.viewers[id].show();
        },
    },
    mounted() {
        this.getErrorReports();
    },
};
</script>

<style lang="scss" scoped></style>
